import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/common/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { show:true },
    component: HomeView
  },
  {
    path: '/scratch-paper',
    name: 'scratch-paper',
    component: () => import('@/views/scratch/ScratchPaperView.vue')
  },
  {
    path: '/question-list',
    name: 'question-list',
    component: () => import('@/views/question/QuestionListView.vue')
  },
  {
    path: '/bank-list',
    name: 'bank-list',
    meta: { show:true },
    component: () => import('@/views/bank/BankListView.vue')
  },
  {
    path: '/discover',
    name: 'discover',
    meta: { show:true },
    component: () => import('@/views/misc/DiscoverView.vue')
  },
  {
    path:'/about',
    name: 'about',
    meta: { show:true},
    component: () => import('@/views/misc/AboutView.vue')
  },
  {
    path: '/daily-question-calendar',
    name: 'daily-question-calendar',
    meta: { show:true },
    component: () => import('@/views/daily/DailyQuestionCalendarView.vue')
  },
  {
    path: '/user',
    name: 'user',
    meta: { show:true, requiresAuth: true },
    component: () => import('@/views/user/UserView.vue'),
    children:[
      {
        path:'info',
        name:'info',
        component: () => import('@/views/user/children/UserInfoView.vue')
      },
      {
        path:'draft-settings',
        name: 'draft-settings',
        component: () => import('@/views/user/children/DraftSettingsView.vue')
      },
      {
        path:'my-bank',
        name:'my-bank',
        component: () => import('@/views/user/children/MyBankView.vue')
      },
      {
        path:'my-star',
        name:'my-star',
        component: () => import('@/views/user/children/MyStarView.vue')
      },
      {
        path:'statistics',
        name:'statistics',
        component: () => import('@/views/user/children/StatisticsView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL), // 改为 createWebHashHistory
  routes
})

// 全局导航守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      // 如果需要登录但未登录，重定向到首页并显示登录窗口
      next({ 
        path: '/',
        query: { showLogin: 'true' }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
